import { IconButton, Tooltip } from '@mui/material'

import RestartFlowModal from 'components/Modals/RestartFlowModal'
import { useBoolean } from 'utils/hook'

import RedoIcon from './RedoIcon'

export default function StartOverButton(): JSX.Element {
  const [isModalOpen, openModal, closeModal] = useBoolean(false)

  return (
    <>
      <Tooltip title="Start flow again">
        <IconButton className="start-over-btn" sx={{ display: 'inline-flex' }} onClick={openModal}>
          <RedoIcon />
        </IconButton>
      </Tooltip>
      {isModalOpen && <RestartFlowModal open={isModalOpen} onClose={closeModal} />}
    </>
  )
}
